import { api } from './client.js';

const root = '/products';

export const publicProductsApi = {
  list: (params) => api.get(root, { query: params }),
  get: (id) => api.get(`${root}/${id}`)
};
